import type { Agent, StudioId } from './types';

/**
 * L5 (D05-05): the studio's own bookings agent: one whose primary studio this
 * is, else one who covers it. Studio managers and Ops aren't on the phones.
 * Pure, so the call routing and the Ops worklist (Anas 8 Oct: whose "Client
 * messaged" is overdue) name the same person.
 */
export function pickStudioAgent<A extends Pick<Agent, 'id' | 'role' | 'primaryStudio' | 'assignedStudios'>>(
  agents: Iterable<A>,
  studioId: StudioId,
): A | undefined {
  const bookingsAgents = [...agents].filter((a) => a.role === 'bookings-agent');
  return bookingsAgents.find((a) => a.primaryStudio === studioId) ?? bookingsAgents.find((a) => a.assignedStudios?.includes(studioId));
}
